import React, { Component } from "react";
import { connect } from "react-redux";
import { Grid, Card, Form } from "tabler-react";

import {
  LoadingButton,
  AlertComponent,
  DateRangePicker,
  MultiSelectCheckboxes,
} from "../../../../component";
import { history } from "../../../../utils/helpers/history";
import { helper } from "../../../../utils/helpers/helper";
import { alertActions, drawingActions } from "../../../../store/actions";
import { formatDate } from "react-day-picker/moment";

import "./style.css";

const defaultState = {
  id: null,
  value: null,
  label: null,
};
let timeoutTime;

class NightlyAlert extends Component {
  constructor(props) {
    super(props);

    this.props.clearAlerts();
    this.modalRef = null;
    history.listen((location, action) => {
      // clear alert on location change
      this.props.clearAlerts();
    });
    this.state = {
      id: null,
      title: "",
      notificationStatus: true,
      status: true,
      startdate: formatDate(new Date(), "YYYY-M-D"),
      enddate: formatDate(helper.getDate(new Date(), 12), "YYYY-M-D"),
      // startdate: new Date(), //new Date('04/13/2020'),
      // enddate: helper.getDate(new Date(), 6), //new Date('04/15/2020'),
      incidentType: defaultState,
      incidentTypeData: null,
      districtType: defaultState,
      districtData: null,
      attack: defaultState,
      attackers: defaultState,
      attackersData: null,
      target: defaultState,
      targetData: null,
      impact: defaultState,
      impactData: [
        {
          id: 1,
          value: "low",
          label: "Low",
        },
        {
          id: 2,
          value: "medium",
          label: "Medium",
        },
        {
          id: 3,
          value: "high",
          label: "High",
        },
      ],
      selectElement: [],
      errors: "", // Initialized to handle validation errors
      history: "", // Initialized to  save browser history and redirection
    };
  }

  escFunction(event) {
    if (event.keyCode === 27) {
      //Do whatever when esc is pressed
      event.preventDefault();
    }
  }
  handleSubmit = (e) => {
    e.preventDefault();
    const {
      id,
      title,
      notificationStatus,
      status,
      startdate,
      enddate,
      incidentType,
      impact,
      target,
      attackers,
    } = this.state;
    const { coordinates } = this.props;

    let validationCheck = this.handleValidation();
    let requestData = {};
    if (validationCheck.date === "" && validationCheck.title === "") {
      if (id === null) {
        const data = {
          support_data: {
            title,
            alert: notificationStatus === true ? "active" : "inactive",
            status: status === true ? "active" : "inactive",
            filters: {
              startdate,
              enddate,
              attack: incidentType,
              impact,
              target,
              attackers,
            },
          },
          points: coordinates.points,
        };
        requestData = {
          data,
          status: "processing",
        };
        this.props.createPolygonSubmit(requestData);
      } else {
        const data = {
          id,
          support_data: {
            title,
            alert: notificationStatus === true ? "active" : "inactive",
            status: status === true ? "active" : "inactive",
            filters: {
              startdate,
              enddate,
              attack: incidentType,
              impact,
              target,
              attackers,
            },
          },
          // points: coordinates.points
        };
        requestData = {
          data,
          status: "updating",
        };
        this.props.updatePolygonSubmit(requestData);
      }
      // this.props.updatePolygon(requestData);
    }
    timeoutTime = setTimeout(() => {
      this.props.clearAlerts();
    }, 4000);
  };

  handleValidation = (e) => {
    let values = this.state;
    // same as above, but feel free to move this into a class method now.
    let errors = {
      date: "",
      title: "",
    };
    if (!values.title) {
      errors.title = "This field is required";
    }
    // if (!values.startdate) {
    //   errors.date = "This field is required";
    // }
    // if (!values.enddate) {
    //   errors.date = "This field is required";
    // }
    this.setState({
      errors: errors,
    });
    return errors;
  };

  handleChange = (e) => {
    if (e.target.name === "notificationStatus") {
      let notiffystate =
        e.target.value === false || e.target.value === "false" ? true : false;
      this.setState({
        [e.target.name]: notiffystate,
      });
    } else if (e.target.name === "status") {
      let notiffystate =
        e.target.value === false || e.target.value === "false" ? true : false;
      this.setState({
        [e.target.name]: notiffystate,
      });
    } else {
      this.setState({
        [e.target.name]: e.target.value.replace(
          /[-!$%^&*()_+|~=:`\\#{}";'<>?,.]/gi,
          ""
        ),
      });
    }
  };

  handleNumberChange = (e) => {
    if (e.charCode !== 45) {
      this.setState({
        [e.target.name]: e.target.value.replace(
          /[-!$%^&*()_+|~=`\\#{}:";'<>?,.^a-zA-Z/]/gi,
          ""
        ),
      });
    }
  };

  getDate = (prop) => {
    const { name, date } = prop;
    this.setState({ [name]: date });
  };

  handleChangeSelect = async (prop) => {
    const { name, value } = prop;
    await this.setState({ [name]: value });
  };

  async recieveMeta(filterMetaData) {
    const {
      incidentType,
      incidentTypeData,
      impact,
      impactData,
      target,
      targetData,
      attackers,
      attackersData,
    } = this.state;

    const select = [
      {
        name: "incidentType",
        placeholder: "Incident Type",
        options: incidentTypeData,
        disabled: false,
        handler: this.handleChangeSelect,
        value: incidentType.value !== null ? incidentType : [],
      },
      {
        name: "attackers",
        placeholder: "Attacker",
        options: attackersData,
        disabled: false,
        handler: this.handleChangeSelect,
        value: attackers.value !== null ? attackers : [],
      },
      {
        name: "target",
        placeholder: "Target",
        options: targetData,
        disabled: false,
        handler: this.handleChangeSelect,
        value: target.value !== null ? target : [],
      },
      {
        name: "impact",
        placeholder: "Impact",
        options: impactData,
        disabled: false,
        handler: this.handleChangeSelect,
        value: impact.value !== null ? impact : [],
      },
    ];
    await this.setState({ selectElement: select }, () => {
      this.forceUpdate();
    });
    return this.state;
  }

  async componentDidMount() {
    document.addEventListener("keydown", this.escFunction, false);
    const { filterMetaData, editPolygon, editPolyData } = this.props;
    const { impactData } = this.state;
    let optionValue = "";

    // Extract incidentType data
    const incidentTypeData = [];
    const incidentTypeOptions = filterMetaData?.attack;
    incidentTypeOptions &&
      incidentTypeOptions.map(function (obj, i) {
        optionValue = {
          id: obj?.id,
          value: obj?.name.toLowerCase(),
          label: obj?.name,
        };
        incidentTypeData.push(optionValue);
        return null;
      });
    // Extract District data
    const districtData = [];
    const districtOptions = filterMetaData?.district;
    districtOptions &&
      districtOptions.map(function (obj, i) {
        optionValue = {
          id: obj?.id,
          value: obj?.name.toLowerCase(),
          label: obj?.name,
        };
        districtData.push(optionValue);
        return null;
      });
    // Extract Atatcker data
    const attackersData = [];
    const attackersOptions = filterMetaData?.attackers;
    attackersOptions &&
      attackersOptions.map(function (obj, i) {
        optionValue = {
          id: obj?.id,
          value: obj?.name.toLowerCase(),
          label: obj?.name,
        };
        attackersData.push(optionValue);
        return null;
      });
    // Extract Target data
    const targetData = [];
    const targetOptions = filterMetaData?.target;
    targetOptions &&
      targetOptions.map(function (obj, i) {
        optionValue = {
          id: obj?.id,
          value: obj?.name.toLowerCase(),
          label: obj?.name,
        };
        targetData.push(optionValue);
        return null;
      });
    if (editPolygon === true) {
      const PolyData = editPolyData.support_data;
      const notificationStatus = PolyData.alert === "active" ? true : false;
      const alertStatus = PolyData.status === "active" ? true : false;
      const filterPolyData = PolyData.filters;
      if (filterPolyData !== []) {
        await this.setState(
          {
            id: editPolyData.id,
            title: PolyData.title,
            notificationStatus: notificationStatus,
            status: alertStatus,
            startdate: filterPolyData.startdate,
            enddate: filterPolyData.enddate,
            incidentType: filterPolyData.attack,
            incidentTypeData: incidentTypeData,
            target: filterPolyData.target,
            targetData,
            attackers: filterPolyData.attackers,
            attackersData,
            impact: filterPolyData.impact,
            impactData: impactData,
          },
          () => {
            this.recieveMeta(filterPolyData);
          }
        );
      }
    } else {
      if (filterMetaData !== []) {
        await this.setState(
          {
            incidentType: incidentTypeData,
            incidentTypeData: incidentTypeData,
            target: targetData,
            targetData: targetData,
            attackers: attackersData,
            attackersData: attackersData,
            impact: impactData,
          },
          () => {
            this.recieveMeta(filterMetaData);
          }
        );
      }
    }
  }

  async componentWillReceiveProps(nextProps, nextState) {
    const { editPolyData } = nextProps;
    if (this.props.editPolyData !== editPolyData) {
      const PolyData = editPolyData.support_data;
      const notificationStatus = PolyData.alert === "active" ? true : false;
      const alertStatus = PolyData.status === "active" ? true : false;
      const filterPolyData = PolyData.filters;
      if (filterPolyData !== []) {
        await this.setState(
          {
            id: editPolyData.id,
            title: PolyData.title,
            notificationStatus: notificationStatus,
            status: alertStatus,
            startdate: filterPolyData.startdate,
            enddate: filterPolyData.enddate,
            incidentType: filterPolyData.attack,
            districtType: filterPolyData.districtType,
            target: filterPolyData.target,
            attackers: filterPolyData.attackers,
            impact: filterPolyData.impact,
          },
          () => {
            this.recieveMeta(filterPolyData);
          }
        );
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.escFunction, false);
    clearTimeout(timeoutTime);
  }

  render() {
    let alertComponent = "";
    const { alert, isNightlyAlert } = this.props;
    const {
      errors,
      title,
      startdate,
      enddate,
      selectElement,
      incidentType,
      status,
    } = this.state;
    if (alert !== {}) {
      alertComponent = alert.message && alert.type && (
        <AlertComponent alert={alert} auth={true} />
      );
    }
    return (
      <Form className="card" onSubmit={this.handleSubmit}>
        <Card.Body>
          <Card.Title>Nightly Alert</Card.Title>
          <Grid.Row>{alertComponent ? alertComponent : null}</Grid.Row>
          <Grid.Row>
            <Grid.Col xs={12} sm={12} md={12} lg={6}>
              <Form.Group
                className="mb-2 col col-xs-12 col-sm-12 col-md-12 col-lg-12"
                isRequired
              >
                <label className="custom-switch">
                  <input
                    type="checkbox"
                    name="status"
                    className="custom-switch-input"
                    defaultValue={status}
                    onClick={this.handleChange}
                    onChange={this.handleChange}
                    checked={status}
                  />
                  <span className="custom-switch-indicator"></span>
                  <span className="custom-switch-description">
                    <Form.Group
                      label="Geofence Status"
                      className="mt-4"
                    ></Form.Group>
                  </span>
                </label>
              </Form.Group>
            </Grid.Col>
            <Grid.Col xs={12} sm={12} md={12} lg={6} className="mb-2 datePickerCustom">
              <Form.Group label="Expiry Date" className="mb-2">
                <DateRangePicker
                  getDate={this.getDate}
                  enddate={enddate}
                  startdate={startdate}
                  error={errors && errors.date ? true : false}
                  onKeyPress={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                  }}
                />
                {/* <DatePickerWithIcon
                  txt="Expiry Date"
                  getDate={this.getDate}
                  name="enddate"
                  value={new Date(enddate)}
                /> */}
              </Form.Group>
            </Grid.Col>
            {incidentType &&
              selectElement &&
              selectElement.map(function (element, i) {
                return (
                  <Grid.Col
                    xs={12}
                    sm={12}
                    md={12}
                    lg={6}
                    key={i}
                    className="mb-2 "
                  >
                    <Form.Group
                      label={element.placeholder}
                      className="mb-2 col col-xs-12 col-sm-12 col-md-12 col-lg-12 select-checkboxes"
                      isRequired
                    >
                      <MultiSelectCheckboxes
                        onChange={element.handler}
                        className="mb-2"
                        name={element.name}
                        options={element.options}
                        isDisabled={element.disabled}
                        value={element.value}
                        placeholder={element.placeholder}
                      />
                    </Form.Group>
                  </Grid.Col>
                );
              })}
            <Grid.Col xs={12} sm={12} md={12} lg={6} className="mb-2 ">
              <Form.Group
                label="Geofence"
                className="mb-2 col col-xs-12 col-sm-12 col-md-12 col-lg-12"
                isRequired
              >
                <Form.Input
                  type="text"
                  name="title"
                  value={title}
                  className="mb-2 "
                  placeholder="Geofence"
                  onChange={this.handleChange}
                  error={errors && errors.title}
                />
              </Form.Group>
            </Grid.Col>
          </Grid.Row>
          <Grid.Row className="card-footContent">
            <LoadingButton
              loadingState={isNightlyAlert}
              preloadingText="Save"
              loadingText="Submitting"
            />
          </Grid.Row>
        </Card.Body>
      </Form>
    );
  }
}
function mapStateToProps(state) {
  const { alert } = state;
  const {
    coordinates,
    editPolygon,
    editPolyData,
    isNightlyAlert,
  } = state.drawing;
  const { filterMetaData } = state.map;
  return {
    alert,
    editPolygon,
    editPolyData,
    coordinates,
    filterMetaData,
    isNightlyAlert,
  };
}

const mapDispatchToProps = {
  errorAlerts: alertActions.error,
  successAlerts: alertActions.success,
  clearAlerts: alertActions.clear,
  closePopup: drawingActions.closePopup,
  createPolygonSubmit: drawingActions.createPolygon,
  updatePolygonSubmit: drawingActions.updatePolygon,
  recievePolycoord: drawingActions.recievePolycoord,
};
export default connect(mapStateToProps, mapDispatchToProps)(NightlyAlert);
